import { render, staticRenderFns } from "./backButton.vue?vue&type=template&id=8bc6ba00"
import script from "./backButton.vue?vue&type=script&lang=js"
export * from "./backButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("G:\\Azure-Agent\\_work\\25\\s\\packages\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bc6ba00')) {
      api.createRecord('8bc6ba00', component.options)
    } else {
      api.reload('8bc6ba00', component.options)
    }
    module.hot.accept("./backButton.vue?vue&type=template&id=8bc6ba00", function () {
      api.rerender('8bc6ba00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleComponents/backButton.vue"
export default component.exports